import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { LoadingComponent } from '../loading/loading.component';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-secondary-button',
  imports: [
    CommonModule,
    MatIconModule,
    LoadingComponent,
    MatRippleModule,
    MatTooltip,
  ],
  templateUrl: './secondary-button.component.html',
  styleUrl: './secondary-button.component.css',
})
export class SecondaryButtonComponent {
  @Input({ required: true }) text: string;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() leadingIcon: string;
  @Input() leadingIconColor = 'text-grey';
  @Input() trailingIcon: string;
  @Input() buttonTooltip = '';

  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();

  handleClick(): void {
    if (this.loading || this.disabled) {
      return;
    }
    this.buttonClicked.emit();
  }
}
